import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditServicestextTwo = () => {
    const [servicetext, setService] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/service-two/${id}`)
            .then((res) => res.json())
            .then((info) => setService(info));
    }, [id]);

    const handleServiceText = (event) => {
        event.preventDefault();
        const servicesubHeadingTwo = event.target.servicesubHeadingTwo.value;
        const serviceHeadingTwo = event.target.serviceHeadingTwo.value;

        const serviceSection = {
            servicesubHeadingTwo,
            serviceHeadingTwo,
        };

        const url = `https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/service-two/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(serviceSection),
        })
            .then((res) => res.json())
            .then((result) => {
                alert('Service Text is Updated');
            });
    };

    return (
        <>
           
            <section id="services" className="services-area vh-100 d-flex align-items-center">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12">
                            <h2 className="text-center mb-4">Update Service Text</h2>
                            <form
                                className="contact-form d-flex flex-column align-items-center"
                                onSubmit={handleServiceText}
                            >
                                <div className="form-group w-100 mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="serviceHeadingTwo"
                                        defaultValue={servicetext.serviceHeadingTwo}
                                        placeholder="Service Heading"
                                        required
                                    />
                                </div>
                                <div className="form-group w-100 mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="servicesubHeadingTwo"
                                        defaultValue={servicetext.servicesubHeadingTwo}
                                        placeholder="Service Sub Heading"
                                        required
                                    />
                                </div>
                                <div className="slider-btn">
                                    <button
                                        className="btn btn-primary btn-lg btn btn-primary"
                                        data-animation="fadeInRight"
                                        data-delay=".8s"
                                    >
                                        Update Services Text
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EditServicestextTwo;
